import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Table, Input, InputNumber, Select, Radio, Checkbox, Popconfirm, DatePicker, Button, Icon, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';
import jquery from 'jquery';

const { Option } = Select;
const { TextArea } = Input;
const RadioGroup = Radio.Group;
const CheckboxGroup = Checkbox.Group;
const { MonthPicker } = DatePicker;
const dateFormat = 'YYYY-MM-DD';

class EditableCell extends Component {
    handleDateChange = (value, dateString) => {
        this.props.onChange(dateString);
    }

    handleRadioChange = (e) => {
        this.props.onChange(e.target.value);
    }

    handleCheckBoxChange = (value) => {
        this.props.onChange(value);
    }

    handleSelectChange = (value) => {
        this.props.onChange(value);
        this.calculateHeight();
    }

    handleInputChange = (e) => {
        this.props.onChange(e.target.value);
    }

    handleInputNumberChange = (value) => {
        this.props.onChange(value);
    }

    calculateHeight = () => {
		setTimeout(() => {
            const dom = ReactDOM.findDOMNode(this);
            const height = jquery(dom).parents('tr').height();
            const table_right = jquery('.ant-table-fixed-right .ant-table-body-outer .ant-table-fixed .ant-table-tbody tr');
            jquery(table_right).eq(this.props.index).height(height);
        }, 300);
    }
    
    disabledDate = (current, ssuModuleStructureDefineIsCheckDate) => {
        if (ssuModuleStructureDefineIsCheckDate == 1) {
            const { maxDate } = this.props;
            const value = moment(moment(maxDate).format(dateFormat)).add(1, 'd').valueOf();
            return current && current.valueOf() >= value;
        }
    }
 
    getWebType = () => {
        const { params = {}, value } = this.props;
        const { ssuDataFormat, ssuModuleStructureDefineWebType, ssuModuleStructureDefineOptionList = [], ssuModuleStructureDefineIsCheckDate } = params;
        let dom = null;
        if (ssuModuleStructureDefineWebType == 'DATE_AREA') {
            const newValue = value ? moment(value) : null;
            if (ssuDataFormat) {
                if (ssuDataFormat.ssuDataFormatValue == 'yyyy-MM-dd') {
                    dom = (
                        <DatePicker
                            value={newValue}
                            placeholder="请选择"
                            onChange={this.handleDateChange}
                            disabledDate={current => this.disabledDate(current, ssuModuleStructureDefineIsCheckDate)}
                        />
                    );
                } else if (ssuDataFormat.ssuDataFormatValue == 'yyyy-MM') {
                    dom = (
                        <MonthPicker
                            value={newValue}
                            placeholder="请选择"
                            onChange={this.handleDateChange}
                        />
                    );
                } else if (ssuDataFormat.ssuDataFormatValue == 'yyyy-MM-dd HH:mm:ss') {
                    dom = (
                        <DatePicker
                            value={newValue}
                            placeholder="请选择"
                            format="YYYY-MM-DD HH:mm:ss"
                            showTime onChange={this.handleDateChange}
                        />
                    );
                }
            }
        } else if (ssuModuleStructureDefineWebType == 'TEXT_RADIO') {
            const options = ssuModuleStructureDefineOptionList.map(i => (
                <Radio
                    key={String(i.ssuModuleStructureDefineOptionId)}
                    value={String(i.ssuModuleStructureDefineOptionId)}
                >{i.ssuModuleStructureDefineOptionName}</Radio>
            ));
            dom = (
                <RadioGroup value={value ? String(value) : ''} onChange={this.handleRadioChange}>
                    {options}
                </RadioGroup>
            );
        } else if (ssuModuleStructureDefineWebType == 'TEXT_CHECKBOX') {
            const options = ssuModuleStructureDefineOptionList.map(i => ({
                label: i.ssuModuleStructureDefineOptionName,
                value: i.ssuModuleStructureDefineOptionId,
            }));
            dom = (
                <CheckboxGroup options={options} value={value} onChange={this.handleCheckBoxChange} />
            );
        } else if (ssuModuleStructureDefineWebType == 'TEXT_SELECT') {
            const options = ssuModuleStructureDefineOptionList.map(i => (
                <Option key={String(i.ssuModuleStructureDefineOptionId)}>{i.ssuModuleStructureDefineOptionName}</Option>
            ));
            dom = (
                <Select placeholder="请选择" value={value} onChange={this.handleSelectChange}>
                    {options}
                </Select>
            );
        } else if (ssuModuleStructureDefineWebType == 'TEXT_SELECT_MULTI') {
            const options = ssuModuleStructureDefineOptionList.map(i => (
                <Option key={String(i.ssuModuleStructureDefineOptionId)}>{i.ssuModuleStructureDefineOptionName}</Option>
            ));
            dom = (
                <Select mode="multiple" filterOption={false} placeholder="请选择" value={value ? value.split(',') : []} onChange={value => this.handleSelectChange(value ? value.join(',') : '')}>
                    {options}
                </Select>
            );
        } else if (ssuModuleStructureDefineWebType == 'TEXT_AREA') {
            dom = (
                <Input maxLength="1000" placeholder="请输入" style={{ width: '100%' }} value={value} onChange={this.handleInputChange} />
            );
        } else if (ssuModuleStructureDefineWebType == 'TEXT_TEXTAREA') {
            dom = (
                <TextArea maxLength="1000" placeholder="请输入" style={{ width: '100%', resize: 'none' }} value={value} onChange={this.handleInputChange} rows={3} />
            );
        } else if (ssuModuleStructureDefineWebType == 'NUMBER_AREA') {
            dom = (
                <InputNumber placeholder="请输入" style={{ width: '100%' }} value={value} onChange={this.handleInputNumberChange} />
            );
        }
        return dom;
    }

    render () {
        const { text, editable } = this.props;
        return (
            <div>
                {
                    editable ?
                        this.getWebType()
                    :
                        text
                }
            </div>
        )
    }
}

class CustomTable extends Component {
    state = {
        count: 0,
        maxDate: '',
        loading: false,
        dataSource: [],
    }

    componentDidMount() {
        this.loadData();
        this.queryEffectiveDate();
    }

    queryEffectiveDate = () => {
        const options = {
            method: 'POST',
            url: API_URL.home.queryEffectiveDate,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { date } = res;
                const maxDate = date;
                this.setState({ maxDate });
            }
        }
        $.sendRequest(options);
    }

    loadData = () => {
        const { tableData } = this.props;
        const { ssuModuleStructureDefineName, ssuHospitalStructureId = '' } = tableData;
        if (!ssuHospitalStructureId) {
            return;
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.hospital.queryTableValue,
            data: {
                ssuHospitalStructureId,
                tableName: ssuModuleStructureDefineName,
            },
            dataType: 'json',
            doneResult: res => {
                const dataSource = this.getDataSource(res.data);
                this.setState({
                    dataSource,
                    loading: false,
                    data: res.data,
                    count: res.data.length || 0,
                }, () => {
                    this.scrollToBottom();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    // 将列表字段中值为id的，转化为name
    getDataSource = (data) => {
        const { tableData } = this.props;
        const { children } = tableData || {};
        const dataSource = [];
        (data || []).forEach((item, index) => {
            const params = {
                edit: null,
            };
            (item.ssuTableValueDetails || []).forEach(i => {
                const { edit, value, ssuModuleStructureDefineId } = i;

                // 将id解析成name
                const fieldOption = (children || []).find(child => child.ssuModuleStructureDefineId == ssuModuleStructureDefineId);
                const { ssuModuleStructureDefineWebType, ssuModuleStructureDefineOptionList } = fieldOption || {};
                switch(ssuModuleStructureDefineWebType) {
                    case 'TEXT_RADIO':
                    case 'TEXT_CHECKBOX':
                    case 'TEXT_SELECT':
                        const option = (ssuModuleStructureDefineOptionList || []).find(i => i.ssuModuleStructureDefineOptionId == value);
                        const { ssuModuleStructureDefineOptionName } = option || {};
                        params[`${ssuModuleStructureDefineId}_text`] = ssuModuleStructureDefineOptionName || '';
                        break;
                    case 'TEXT_SELECT_MULTI':
                        const valueList = (value || '').split(',');
                        const nameList = [];
                        valueList.forEach(id => {
                            const option = (ssuModuleStructureDefineOptionList || []).find(i => i.ssuModuleStructureDefineOptionId == id);
                            const { ssuModuleStructureDefineOptionName } = option || {};
                            nameList.push(ssuModuleStructureDefineOptionName || '');
                        });
                        params[`${ssuModuleStructureDefineId}_text`] = nameList.join(';');
                        break;
                    default:
                        params[`${ssuModuleStructureDefineId}_text`] = value;

                }

                params[ssuModuleStructureDefineId] = value;
                if (edit === false) {
                    params.edit = false;
                }
            });
            dataSource.push({
                key: index,
                ...params,
                ssuTableValueId: item.ssuTableValueId,
            });
        });
        return dataSource;
    }

    saveData = (params) => {
        const { hospitalId, tableData } = this.props;
        const {
            ssuModuleStructureId,
            ssuModuleStructureDefineId,
            ssuHospitalStructureId = null,
        } = tableData;
        const newParams = {
            ...params,
            ssuModuleStructureId,
            ssuModuleStructureDefineId,
        };
        if (ssuHospitalStructureId) {
            newParams.ssuHospitalStructureId = ssuHospitalStructureId;
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.hospital.addTableValue,
            data: {
                hospitalId,
                ...newParams,
            },
            dataType: 'json',
            doneResult: res => {
                if (!res.error) {
                    message.success(res.success);
                    if (res.ssuHospitalStructureId) {
                        this.props.saveHospitalStructureId(ssuModuleStructureDefineId, res.ssuHospitalStructureId);
                    }
                    this.loadData();
                }
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    cancelData = (ssuTableValueId) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.hospital.deleteTableValue,
            data: {
                ssuTableValueId,
            },
            dataType: 'json',
            doneResult: res => {
                if (!res.error) {
                    message.success(res.success);
                    this.loadData();
                }
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    getShowState = (data, target) => {
        if (!data) return true;

        let isShow = false;
        const { edit } = this.props;
        if ((data.ssuModuleStructureDefineDisplayDetailList || []).length > 0) {
            if (data.oper == 'AND') {
                isShow = data.ssuModuleStructureDefineDisplayDetailList.every(item => {
                    const value = target[item.refSsuModuleStructureDefineId];
                    if (item.detailOper == 'EQ') {
                        if (edit) {
                            if (Array.isArray(value)) {
                                return value.indexOf(Number(item.value)) >= 0;
                            } else {
                                return item.value == value;
                            }
                        } else {
                            return (value || '').indexOf(item.value) >= 0;
                        }
                    } else if (item.detailOper == 'NEQ') {
                        if (edit) {
                            if (Array.isArray(value)) {
                                return value.indexOf(Number(item.value)) < 0;
                            } else {
                                return item.value != value;
                            }
                        } else {
                            return (value || '').indexOf(item.value) < 0;
                        }
                    }
                });
            } else if (data.oper == 'OR') {
                isShow = data.ssuModuleStructureDefineDisplayDetailList.some(item => {
                    const value = target[item.refSsuModuleStructureDefineId];
                    if (item.detailOper == 'EQ') {
                        if (edit) {
                            if (Array.isArray(value)) {
                                return value.indexOf(Number(item.value)) >= 0;
                            } else {
                                return item.value == value;
                            }
                        } else {
                            return refValue.indexOf(item.value) >= 0;
                        }
                    } else if (item.detailOper == 'NEQ') {
                        if (edit) {
                            if (Array.isArray(value)) {
                                return value.indexOf(Number(item.value)) < 0;
                            } else {
                                return item.value != value;
                            }
                        } else {
                            return refValue.indexOf(item.value) < 0;
                        }
                    }
                });
            }
        }
        return isShow;
    }

    renderColumns = (text, value, record, params, index) => {
        const { maxDate, dataSource } = this.state;
        const isShow = this.getShowState(params.ssuModuleStructureDefineDisplay, dataSource[index]);
        
        if (!isShow) return null;
        return (
            <EditableCell
                editable={record.editable}
                text={text}
                value={value}
                index={index}
                params={params}
                maxDate={maxDate}
                onChange={value => this.handleChange(value, record.key, params.ssuModuleStructureDefineId)}
            />
        );
    }

    handleChange = (value, key, column) => {
        const newData = [...this.state.dataSource];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
            target[column] = value;
            this.setState({ dataSource: newData });
        }
    }

    edit = (key) => {
        const newData = [...this.state.dataSource];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
            target.editable = true;
            this.setState({ dataSource: newData });
        }
    }

    save = (key) => {
        const newData = [...this.state.dataSource];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
            const { tableData } = this.props;
            const { children = [] } = tableData;

            const params = {};

            let idx = 0;
            for (let i = 0, len = children.length; i < len; i++) {
                const { ssuModuleStructureDefineId, ssuModuleStructureDefineName, ssuModuleStructureDefineWebType,
                    ssuModuleStructureDefineIsRequire, ssuModuleStructureDefineDisplay } = children[i];

                const isShow = this.getShowState(ssuModuleStructureDefineDisplay, target);

                if (!isShow) {
                    params[`ssuTableValueDetails[${idx}].ssuModuleStructureDefineId`] = ssuModuleStructureDefineId;
                    params[`ssuTableValueDetails[${idx++}].value`] = '';
                    continue;
                };
                if (ssuModuleStructureDefineIsRequire == 1 && !target[ssuModuleStructureDefineId]) {
                    if (ssuModuleStructureDefineWebType == 'DATE_AREA') {
                        message.warning(`请选择${ssuModuleStructureDefineName}`);
                        return;
                    }
                }
                params[`ssuTableValueDetails[${idx}].ssuModuleStructureDefineId`] = ssuModuleStructureDefineId;
                params[`ssuTableValueDetails[${idx++}].value`] = target[ssuModuleStructureDefineId];

            }

            if ( target.ssuTableValueId) {
                params.ssuTableValueId = target.ssuTableValueId;
            }

            delete target.editable;
            this.setState({ dataSource: newData }, () => {
                this.saveData(params);
            });
        }
    }

    cancel = (key) => {
        const newData = [...this.state.dataSource];
        let idx;
        newData.forEach((item, index) => {
            if (item.key == key) {
                if (item.ssuTableValueId) {
                    this.cancelData(item.ssuTableValueId);
                } else {
                    idx = index;
                }
            }
        });
        if (idx || idx === 0) {
            newData.splice(idx, 1);
            this.setState({ dataSource: newData });
        }
    }

    getColumns = () => {
        const { edit, tableData } = this.props;
        const { children = [] } = tableData;
        const columns = [];
        children.forEach(item => {
            const { ssuModuleStructureDefineId, ssuModuleStructureDefineName } = item;
            columns.push({
                title: ssuModuleStructureDefineName,
                dataIndex: `${ssuModuleStructureDefineId}_text`,
                key: `${ssuModuleStructureDefineId}_text`,
                width: 160,
                render: (text, record, index) => (
                    this.renderColumns(text, record[ssuModuleStructureDefineId], record, item, index)
                ),
            });
        });
        
        const isFixed = children.length > 2; 
        if (edit) {
            columns.push({
                title: '',
                key: 'operation',
                width: 80,
                fixed: isFixed && 'right',
                render: (text, record, index) => {
                    const { editable } = record;
                    return (
                        <span>
                            {
                                editable ?
                                    <a onClick={() => this.save(record.key)}>保存</a>
                                :
                                    <a onClick={() => this.edit(record.key)}>修改</a>
                            }
                            <span className="ant-divider" />
                            <Popconfirm title="确定要删除该行数据?" onConfirm={() => this.cancel(record.key)}>
                                <a>删除</a>
                            </Popconfirm>
                        </span>
                    )
                },
            });
        }
        return columns;
    }

    handleAdd = () => {
        const { tableData } = this.props;
        const { children = [] } = tableData;
        const { count, dataSource } = this.state;
        const params = {};
        children.forEach(item => {
            params[item.ssuModuleStructureDefineId] = '';
        });
        const newData = {
          key: count,
          ...params,
          editable: true,
        };
        this.setState({
          dataSource: [...dataSource, newData],
          count: count + 1,
        }, () => {
            this.scrollToBottom();
        });
    }

    scrollToBottom = () => {
        setTimeout(() => {
            const tableDom = ReactDOM.findDOMNode(this.tableRef);
            const containDom = jquery(tableDom).find('.ant-table-scroll .ant-table-body')[0];
            if (containDom) {
                const clientHeight = containDom.clientHeight;
                const scrollHeight = jquery(containDom).find('table')[0] && jquery(containDom).find('table')[0].scrollHeight;
                containDom.scrollTop = scrollHeight - clientHeight;
            }
        }, 100);
    }

    render() {
        const { loading, dataSource } = this.state;
        const { edit, tableData } = this.props;
        const { children = [], tipInfo } = tableData;
        const scroll = {};
        if (dataSource.length > 3) {
            scroll.y = 160;
        }
        if (edit) {
            if (children.length > 2) {
                scroll.x = children.length * 120 + 80;
            }
        } else {
            if (children.length > 3) {
                scroll.x = children.length * 120;
            }
        }
        return (
            <div style={{ marginBottom: 10 }}>
                { tipInfo &&
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10, color: '#5750c9', lineHeight: '18px' }}>
                        <Icon style={{ marginTop: 8, marginRight: 4, fontSize: '14px' }} type="info-circle" />
                        <span>{tipInfo}</span>
                    </div>
                }
                { edit && <Button onClick={this.handleAdd} style={{ marginBottom: 10 }}>添加行</Button> }
                <Table
                    ref={el => this.tableRef = el}
                    scroll={scroll}
                    loading={loading}
                    pagination={false}
                    columns={this.getColumns()}
                    dataSource={dataSource}
                    rowClassName={(record, index) => {
                        if(record.edit === false){
                            return "bg_gray";
                        }
                    }}
                />
            </div>
        )
    }
}

export default CustomTable;


// WEBPACK FOOTER //
// ./src/components/common/workFlowTemplate/CustomTable.js